var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "questionnaireModuleHeader",
        attrs: { id: _vm.template.id },
      },
      [
        _c("span", { staticClass: "questionnaireModuleHeaderText" }, [
          _vm._v(_vm._s(_vm.template.name)),
        ]),
      ]
    ),
    _c(
      "div",
      _vm._l(_vm.modelCells, function (section) {
        return _c("questionnaire-form-section", {
          key: section.id,
          attrs: {
            config: _vm.config,
            globals: _vm.globals,
            model: section,
            response: _vm.response,
            template: _vm.getTemplate(section.id),
          },
          on: { change: _vm.$rbEmit, stateChange: _vm.$rbEmit },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }